import React from 'react';
import Box from '../../../../../Box';
import Ellipse from './Ellipse/Ellipse';
import styles from './Colon.module.css';

const Colon = () => {
  return (
    <Box className={styles.colon}>
      <Ellipse />
      <Ellipse />
    </Box>
  );
};

export default Colon;
